module.exports = __webpack_public_path__ + "img/clients2-1680.d1fd87e.png";